import { toast } from 'sonner';

export const SuccessToast = (message: string) => {
  toast.success(message, {
    style: {
      borderRadius: '0px',
      background: '#5a6f3e',
      color: '#fff',
      fontFamily: 'Jost, sans-serif',
      border: '1px solid #d4af37',
    },
  });
};

export const ErrorToast = (message: string) => {
  toast.error(message, {
    style: {
      borderRadius: '0px',
      background: '#2a2520',
      color: '#fff',
      fontFamily: 'Jost, sans-serif',
      border: '1px solid #ff4b4b',
    },
  });
};
